import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class APIRestrictionGrid extends BaseComponent {

	constructor() {
		super();
		
		var apiRestrictedGrid = this;
		setTimeout(function(){
			apiRestrictedGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var apiRestrictedGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',				
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_API_RESTRICTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							addEditAction();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_API_RESTRICTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							addEditAction(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['ADMIN_API_RESTRICTION_POLICY:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'policyId',
					header: 'Policy Id',
					width: '5em'						
				},
				{						
					path: 'companyId',
					header: 'Company Id',
					width: '5em'						
				},
				{						
					path: 'companyName',
					header: 'Company Name',
					width: '5em'
				},				
				{						
					path: 'username',
					header: 'Username',
					width: '5em'
				},							
				{						
					path: 'requestLimitPerMinute',
					header: 'Request Limit Per Minute',					
					width: '5em'
				},
				{
					path: 'resetLimitSeconds',
					header: 'Reset Limit Seconds',					
					'text-align': 'center',
					'flex-grow': '1'
				},							
				{
					path: 'captureRequestResponseBody',
					header: 'Capture Request/Respond',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'bufferPolicies',
					header: 'Buffer Policies',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData) {						
						if (rowData.item.bufferPolicies && rowData.item.bufferPolicies.length > 0) {
							root.innerHTML =  rowData.item.bufferPolicies.length + ' Buffer Policies';
						} else {
							root.innerHTML = 'No Buffer Policies';
						}
						
					}				
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true; 
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'api-restrictions',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'api-restrictions.csv');
			}
		});

		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		apiRestrictedGrid.append(gridLayout);
		
	
		
		var actionRefresh = function() {
					
			var loadMask = grid.showLoading();
			Service.getApiService().getAPIRestrictions().then(function(policies){						
				grid.activeItem = null;
				grid.items = policies.data;
				loadMask.remove();
			});
		};
		actionRefresh();
	
		var addEditAction = function(record) {
		
			var showAddEditForm = function (selectedCompanyId, record) {

				var addWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: (record ? 'Edit Policy' : 'Add Policy'),
					icon: 'vaadin:plus',
					listeners: {
						ready: function () {
							addWin.show();

							var bufferPolicies = [];
							var bufferGrid = ElementUtil.create({
								tag: 'vaadin-grid',
								theme: 'row-stripes column-borders',
								'column-reordering-allowed': '',
								style: 'height: 100%;',
								slot: 'primary',
								defaults: {
									tag: 'vaadin-grid-sort-column',
									resizable: true				
								},			
								children: [								
									{						
										path: 'dataType',
										header: 'Data Type',					
										width: '9em'
									},								
									{
										path: 'dataFilterDescription',
										header: 'Data Filter',
										width: '9em'
									},
									{
										path: 'autoUnitDescription',
										header: 'Auto Unit',
										width: '9em'
									},
									{
										path: 'gpsFilterDescription',
										header: 'GPS Filter',
										width: '9em'
									},
									{
										path: 'gpsFilterOff',
										header: 'GPS Filter Off',
										'text-align': 'center',
										width: '7em'
									},
									{
										path: 'unitMatchingDescription',
										header: 'Unit Matching',
										width: '9em'
									},
									{
										path: 'expirationMinutes',
										header: 'Expiration Minutes',
										width: '9em'
									},
									{
										path: 'bufferSize',
										header: 'Buffer Size',
										width: '9em'
									}
								],
								listeners: {
									'active-item-changed': function(event) {
										const item = event.detail.value;
										bufferGrid.selectedItems = item ? [item] : [];
										if (bufferGrid.selectedItems.length > 0) {											
											ElementUtil.query(formPanel, 'editBuffer').disabled = false;										
											ElementUtil.query(formPanel, 'removeBuffer').disabled = false;										
										} else {	
											ElementUtil.query(formPanel, 'editBuffer').disabled = true;										
											ElementUtil.query(formPanel, 'removeBuffer').disabled = true;
										}	
									}
								}
							});

							var formPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-combo-box',												
												'class': 'spacer-toolbar-item',
												name: 'username',															
												label: 'User',
												'item-value-path': 'code',
												'item-label-path': 'description',
												postinit: function(combo) {
													
													Service.getApiService().getAPIRestrictionServiceAccounts(selectedCompanyId).then(function(data){
														combo.items = data;
													});
												},
												placeHolder: 'Select'
											}
										]
									},	
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-number-field',
												name: 'requestLimitPerMinute',
												label: 'Request Limit Per Minute',
												required: true,
												min: 1,
												max: 1000
											},
											{
												tag: 'vaadin-number-field',
												name: 'resetLimitSeconds',
												label: 'Reset Limit Seconds',
												required: true,
												min: 1,
												max: 3600
											},
											{
												tag: 'vaadin-checkbox',
												name: 'captureRequestResponseBody',
												label: 'Capture Request/Response'
											},
											{
												tag: 'dl-section-title',
												title: 'Buffer Policies',
												colspan: 2,
												style: 'margin-top: 20px;'
											}
										]
									},									
									{
										tag: 'div',
										style: 'height: 350px;',
										colspan: 2,
										children: [
											{
												tag: 'dl-flex-layout',
												children: [														
													{
														tag: 'dl-toolbar',
														slot: 'toolbar',
														theme: 'spacing',
														children: [																				
															{
																tag: 'vaadin-button',																	
																theme: 'primary',
																'class': 'spacer-toolbar-item',
																children:[
																	ElementUtil.makeIcon('vaadin:plus', ' Add')
																],
																listeners: {
																	click: function() {							
																		actionAddEditBuffer();
																	}
																}					
															},	
															{
																tag: 'vaadin-button',
																itemid: 'editBuffer',																	
																'class': 'spacer-toolbar-item',
																children:[
																	ElementUtil.makeIcon('vaadin:edit', ' Edit')
																],
																listeners: {
																	click: function() {							
																		actionAddEditBuffer(bufferGrid.selectedItems[0]);
																	}
																}					
															},
															{
																tag: 'vaadin-button',
																itemid: 'removeBuffer',
																theme: 'error primary',																						
																'class': 'spacer-toolbar-item',
																style: 'float: right;',					
																children:[
																	ElementUtil.makeIcon('vaadin:close', ' Remove')
																],
																listeners: {
																	click: function() {
																		actionRemoveBuffer(bufferGrid.selectedItems[0]);
																	}
																}
															}			
														]
													},
													bufferGrid													
												]
											}
										]
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:database', ' Save')
												],
												listeners: {
													click: function () {

														formPanel.submitForm({
															preSubmit: function (data) {
																//add buffers
																data.bufferPolicies = bufferPolicies;
																return data;
															},
															actualCall: function (data) {
																if (record) {
																	data.policyId = record.policyId;
																}
																data.companyId = selectedCompanyId; 
																return Service.getApiService().saveAPIRestrictions(data, (record ? true : false));
															},
															success: function (data, responseData) {
																window.DL.MessageUtil.showToast('Success', 'Saved API Policy', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																actionRefresh();
																addWin.close();
															}
														});
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														addWin.close();
													}
												}
											}
										]
									}
								]
							});

							addWin.addToContentElement(formPanel);
							
							var actionRefreshBufferPolicies = function() {														
								bufferGrid.activeItem = null;
								bufferGrid.items = bufferPolicies.slice(0);	
							};
							
							
							if (record) {	
								formPanel.load(record);

								//load rules
								bufferPolicies = [];							
								record.policyViews.forEach(function(buffer){										
									bufferPolicies.push(Object.assign({}, buffer));
								});

								actionRefreshBufferPolicies();
							}							
							
							var actionRemoveBuffer = function(rule) {
								var newItems = [];
								bufferPolicies.forEach(function(item){
									if (item.dataType !== rule.dataType) {
										newItems.push(item);
									}
								});	
								bufferPolicies = newItems;
								actionRefreshBufferPolicies();
							};

							var actionAddEditBuffer = function(bufferRecord) {
								
								var showAddEditBuffer = function(dataType) {
									var addEditBufferWin = ElementUtil.create({
										tag: 'dl-dialog',
										title: bufferRecord ? 'Edit' : 'Add',
										icon: 'vaadin:edit',
										width: 600,
										height: 550,
										listeners: {
											ready: function () {
												addEditBufferWin.show();

												var bufferFormPanel = ElementUtil.create({
													tag: 'dl-form-panel',
													itemid: 'form',
													children: [
														{
															tag: 'vaadin-form-layout',
															children: [
																{
																	tag: 'vaadin-combo-box',
																	itemId: 'dataFilterId',
																	name: 'dataFilterId',
																	label: 'Data Filter',																
																	'item-value-path': 'datafilterId',
																	'item-label-path': 'name',															
																	postinit: function (combo) {																
																		Service.getApiService().getDataFilters(selectedCompanyId).then(function(results){																	
																			combo.items = results;
																		});																
																	}
																},
																{
																	tag: 'vaadin-combo-box',
																	itemId: 'unitMatching',
																	name: 'unitMatching',
																	label: 'Unit Matching Rules',																	
																	'item-value-path': 'unitMatchId',
																	'item-label-path': 'name',															
																	postinit: function (combo) {																
																		Service.getApiService().getUnitMatchingRules(selectedCompanyId).then(function(results){																	
																			combo.items = results;
																		});																
																	}
																},
																{
																	tag: 'vaadin-combo-box',
																	itemId: 'autoUnitId',
																	name: 'autoUnitId',
																	label: 'Auto Unit Rules',																	
																	'item-value-path': 'autoUnitId',
																	'item-label-path': 'name',
																	placeHolder: 'System Default - Auto Tractors',
																	clearButtonVisible: true,
																	postinit: function (combo) {																
																		Service.getApiService().getAutoUnits(selectedCompanyId).then(function(results){
																			var all = [];
																			(results || []).forEach(function(item){
																				all.push(item);
																			});
																			all.push({
																				autoUnitId: 'NO_AUTO_UNIT',
																				name: 'No Auto Unit Creation'
																			});
																			combo.items = all;
																		});																
																	}
																},
																{
																	tag: 'vaadin-combo-box',
																	itemId: 'autoUnitId',
																	name: 'gpsFilterId',
																	label: 'GPS Filtering',																	
																	'item-value-path': 'gpsFilterId',
																	'item-label-path': 'name',															
																	placeHolder: 'Default',
																	postinit: function (combo) {																
																		Service.getApiService().getGPSFilters(selectedCompanyId).then(function(results){
																			var all = [];
																			results.forEach(function(item){
																				all.push(item);
																			});
																			all.push({
																				gpsFilterId: 'NO_FILTER',
																				name: 'No Filter'
																			});
																			combo.items = all;
																		});																
																	}
																},	
																{
																	tag: 'vaadin-number-field',
																	itemid: 'expirationMinutes',
																	name: 'expirationMinutes',
																	label: 'Expiration Minutes',																	
																	min: 0,
																	max: (1440*30)
																},
																{
																	tag: 'vaadin-number-field',
																	itemid: 'bufferSize',
																	name: 'bufferSize',
																	label: 'Buffer Size',																	
																	min: 0,
																	max: 10000000
																},																
																{
																	tag: 'hr',
																	colspan: 2
																},
																{
																	tag: 'div',
																	style: 'text-align: center;',
																	colspan: 2,
																	defaults: {
																		tag: 'vaadin-button'
																	},
																	children: [
																		{
																			theme: 'primary',
																			children: [
																				ElementUtil.makeIcon('vaadin:database', (bufferRecord ? ' Update' : ' Add'))
																			],
																			listeners: {
																				click: function () {

																					//get data
																					var data = bufferFormPanel.getData();
																					
																					if (data.gpsFilterId && data.gpsFilterId === 'NO_FILTER') {
																						delete data.gpsFilterId;
																						data.gpsFilterOff = true;
																					}
																					data.dataType = dataType;
																					
																					var dataFilteringCB = ElementUtil.query(bufferFormPanel, 'dataFilterId');
																					if (dataFilteringCB) {
																						if (dataFilteringCB.selectedItem) {
																							data.dataFilterDescription = dataFilteringCB.selectedItem.name;
																						}
																					}
																					var unitMatchingCB = ElementUtil.query(bufferFormPanel, 'unitMatching');
																					if (unitMatchingCB) {
																						if (unitMatchingCB.selectedItem) {
																							data.unitMatchingDescription = unitMatchingCB.selectedItem.name;
																						}
																					}
																					var autoUnitsCB = ElementUtil.query(bufferFormPanel, 'autoUnitId');
																					if (autoUnitsCB) {
																						if (autoUnitsCB.selectedItem) {
																							data.autoUnitDescription = autoUnitsCB.selectedItem.name;
																						}
																					}
																					var gpsFilteringCB = ElementUtil.query(bufferFormPanel, 'gpsFilterId');
																					if (gpsFilteringCB) {
																						if (gpsFilteringCB.selectedItem) {
																							data.gpsFilterDescription = gpsFilteringCB.selectedItem.name;
																						}
																					}																					
																					
																					//add record
																					if (!bufferRecord) {
																						bufferPolicies.push(data);
																					} else {
																						bufferRecord.dataFilterId = data.dataFilterId;
																						bufferRecord.autoUnitId = data.autoUnitId;
																						bufferRecord.gpsFilterId = data.gpsFilterId;
																						bufferRecord.gpsFilterOff = data.gpsFilterOff;
																						bufferRecord.unitMatching = data.unitMatching;
																						
																						bufferRecord.dataFilterDescription = data.dataFilterDescription;
																						bufferRecord.autoUnitDescription = data.autoUnitDescription;
																						bufferRecord.unitMatchingDescription = data.unitMatchingDescription;																						
																						bufferRecord.gpsFilterDescription = data.gpsFilterDescription;
																						
																						bufferRecord.expirationMinutes = data.expirationMinutes;
																						bufferRecord.bufferSize = data.bufferSize;
																					}

																					//refresh rules
																					actionRefreshBufferPolicies();
																					addEditBufferWin.close();
																				}
																			}
																		},
																		{
																			theme: 'tertiary',
																			innerHTML: 'Cancel',
																			style: 'margin-left: 10px;',
																			listeners: {
																				click: function () {
																					//cancel
																					addEditBufferWin.close();
																				}
																			}
																		}
																	]
																}
															]
														}
													]
												});

												addEditBufferWin.addToContentElement(bufferFormPanel);

												if (bufferRecord) {
													bufferFormPanel.load(bufferRecord);
												}

											}
										}
									});
								};
								
																
								if (bufferRecord) {
									showAddEditBuffer(bufferRecord.dataType);
								} else {							
									var addBufferPromptWin = ElementUtil.create({
										tag: 'dl-dialog',
										title: 'Select Data Type',
										icon: 'vaadin:plus',
										width: 600,
										height: 250,
										listeners: {
											ready: function () {
												addBufferPromptWin.show();

												var formPanel = ElementUtil.create({
													tag: 'dl-form-panel',
													itemid: 'form',
													children: [
														{
															tag: 'vaadin-form-layout',
															children: [
																{
																	tag: 'vaadin-combo-box',
																	itemid: 'dataTypeCB',
																	name: 'dataType',
																	label: 'Data Type',
																	'item-value-path': 'code',
																	'item-label-path': 'description',											
																	required: true,
																	postinit: function (combo) {
																		Service.getLookupService().getLookupValues('DataType').then(function (data) {
																			var available = [];
																			
																			var existing = {};
																			bufferPolicies.forEach(function(buffer){
																				existing[buffer.dataType] = true;
																			});
																			
																			data.forEach(function(item){
																				if (!existing[item]) {
																					available.push(item);
																				}
																			});

																			combo.items = available;
																		});
																	},
																	placeHolder: 'Select'
																}
															]
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Select')
																	],
																	listeners: {
																		click: function () {
																			var formData = formPanel.getData();
																			if (formPanel.isValid()) {
																				showAddEditBuffer(formData.dataType, bufferRecord);
																				addBufferPromptWin.close();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			addBufferPromptWin.close();
																		}
																	}
																}
															]
														}
													]
												});

												addBufferPromptWin.addToContentElement(formPanel);
											}
										}
									});	
									
								}
							};							
							
						}
					}
				});
			};		
		
			if (record) {
				showAddEditForm(record.companyId, record);								
			} else {
				
				var addPromptWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Select Company',
					icon: 'vaadin:plus',
					width: 600,
					height: 250,
					listeners: {
						ready: function () {
							addPromptWin.show();

							var formPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-form-layout',
										children: [
											{
												tag: 'vaadin-combo-box',	
												itemId: 'company',
												'class': 'spacer-toolbar-item',
												'keep-open': true,																
												label: 'Company',
												'item-value-path': 'code',
												'item-label-path': 'description',	
												name: 'companyId',
												required: true,
												postinit: function(combo) {
													Service.getApiService().getAPIRestrictionCompanies().then(function(data){
														combo.items = data;
													});
												},
												placeHolder: 'Select',
												listeners: {
													change: function() {
													}
												}												
											}
										]
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:database', ' Select')
												],
												listeners: {
													click: function () {
														var formData = formPanel.getData();
														if (formPanel.isValid()) {															
															showAddEditForm(formData.companyId, record);	
															addPromptWin.close();
														}
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														addPromptWin.close();
													}
												}
											}
										]
									}
								]
							});

							addPromptWin.addToContentElement(formPanel);
						}
					}
				});				
				
			}
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete selected policy"?</b>',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							Service.getApiService().deleteAPIRestriction(record.policyId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed Policy: '+ record.policyId, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};		
		
	}
	
};
customElements.define('dl-api-restrictions-grid', APIRestrictionGrid);
